import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Task } from "@app/maintenance/components/task/task.model";
import { BaseData } from "@app/maintenance/models/logical-grouper/base-data.model";
import { LinkData } from "@app/maintenance/models/logical-grouper/link-data.model";
import { TaskSelectionModalComponent } from "../task-selection-modal/task-selection-modal.component";

@Component({
    selector: "app-logical-grouper",
    templateUrl: "./logical-grouper.component.html",
    styleUrls: ["./logical-grouper.component.scss"],
})
export class LogicalGrouperComponent implements OnInit {
    @ViewChild(TaskSelectionModalComponent, {static: false}) modal: TaskSelectionModalComponent;

    @Input() items: Task[] = [];
    @Input() baseData: BaseData;
    @Input() linkData: LinkData;
    @Input() isSelectable = false;
    @Input() isSelected = false;
    @Input() descriptionForm: UntypedFormControl = new UntypedFormControl("");
    @Input() dropdownItems: any[] = [];
    @Input() readonly = false;
    @Input() grouperOnly = false;
    @Input() isMandatory = false;

    @Output() linkClicked = new EventEmitter<any>();
    @Output() itemClicked = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() select = new EventEmitter<any>();

    isContentVisible = false;
    isDescriptionVisible = false;

    constructor() {
    }

    ngOnInit() {
        this.descriptionForm.setValue(this.baseData.tooltipDescription);
    }

    toggleDropdown(): void {
        this.isContentVisible = !this.isContentVisible;
    }

    toggleDescription(): void {
        this.isDescriptionVisible = !this.isDescriptionVisible;
    }

    toggleSelected(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        this.select.emit();
    }

    onLinkClicked() {
        this.linkClicked.emit(this.linkData.link);
    }

    openSelectionModal(): void {
        this.modal.open(this.items);
    }

    handleSelectTasks(event: any) {
        if (!event.tasks) {
            return;
        }
        this.items = event.tasks;
        this.modal.close();
    }

    onDeleteTask(event: any) {
        this.items = this.items.filter(item => item.id !== event.id);
    }

    onDeleteRecurrence(event: any) {
        event.preventDefault();
        event.stopPropagation();

        this.delete.emit();
    }

    onItemClicked(event: any) {
        this.itemClicked.emit(event);
    }

    get selectedItems() {
        return this.items;
    }
}
